import {axiosInstance} from '@/services/axiosInstance'

export const MerchantManagerResource = {
  getById: (parametros) => {
    return axiosInstance.get(
      'v1/merchantmanager/:idMerchant',
      {
        urlParams: parametros
      }
    )
  },
  
  registerMerchantManager: (parametros) =>
  {
      return axiosInstance.post( 'v1/merchantmanager',
      parametros
      )
  },
  
   updateMerchantManager: (parametros) =>
  {
      return axiosInstance.put( 'v1/merchantmanager',
      parametros
      )
  },

 

 
}